import {
    Box,
    Button,
    Card,
    Checkbox,
    Container,
    FormControl,
    FormLabel,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    TextField,
    Typography,
  } from '@mui/material';
  import React, { useEffect, useState } from 'react';
  import { Helmet } from 'react-helmet-async';
  import { useLocation, useNavigate } from 'react-router-dom';
  import imageCompression from 'browser-image-compression';
  import { FaArrowLeftLong } from 'react-icons/fa6';
  import { SlCloudUpload } from 'react-icons/sl';
  import Swal from 'sweetalert2';
  import { LoadingButton } from '@mui/lab';
  import { createCategory, updateRefill, updateAroundUs, getBnbList, uploadFile, updateTwilioNumbers } from '../../helper/backend_helper';
  import appConfig from '../../config';
  import InfoTooltip from '../InfoTooltip';

  const UpdatePhoneNumber = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const userData = location?.state?.userData;
    const [name, setName] = useState(userData?.name);
    const [number, setNumber] = useState(userData?.number);
  

  
   
    const [loading, setLoading] = useState(false);
  
  
    const handleUpdate = async () => {
      try {
        setLoading(true);
        
        
        
      
  
  
    
        if (!name) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Name is required',
          });
          setLoading(false);
          return;
        }
       
        if (!number) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Number is required',
          });
          setLoading(false);
          return;
        }
   
   
  
        const Categorydata = {
 
          name,
          number
        };
        console.log(Categorydata);
        const Categoryheaders = {
          headers: {
            'Content-Type': 'application/json',
          },
        };
  
        const response = await updateTwilioNumbers(userData?._id,Categorydata, Categoryheaders);
  
     
  
        // Show success message
        Swal.fire({
          icon: 'success',
          title: 'Twilio Number updated successfully',
        });
      
       
  
        setLoading(false);
      } catch (error) {
        console.error('Error:', error);
        setLoading(false);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: `${error?.response?.data?.errors[0]?.message}`,
        });
      }
    };
  
    return (
      <>
        <Helmet>
          <title> update Twilio Number  </title>
        </Helmet>
        <Card sx={{ padding: 3 }}>
          <Stack
            onClick={() => navigate(-1)}
            gap={3}
            sx={{ cursor: 'pointer', mb: 3 }}
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
          >
            <FaArrowLeftLong size={24} />
            <Typography variant="h4">Update Phone Number</Typography>
          </Stack>
  
          <Box
            component="form"
            sx={{
              '& .MuiTextField-root': { width: '50ch' },
            }}
            noValidate
            autoComplete="off"
          >
      
           
            <Stack sx={{ marginTop: 2 }}>
              <FormLabel sx={{ mb: 1 }}>Name <InfoTooltip title="A friendly label to identify this Twilio phone number in the admin list." /></FormLabel>
              <TextField
                label="Enter Name"
                id="outlined-size-small"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Stack>
            <Stack sx={{ marginTop: 2 }}>
              <FormLabel sx={{ mb: 1 }}>Number <InfoTooltip title="The Twilio phone number in full international format, used to send and receive guest messages." /></FormLabel>
              <TextField
                type='number'
                label="Enter Number"
                id="outlined-size-small"
                value={number}
                onChange={(e) => setNumber(e.target.value)}
              />
            </Stack>
  
        
  
       
          </Box>
          <LoadingButton
            sx={{
              width: 100,
              mt: 4,
              mb: 4,
              boxShadow: 'none',
              backgroundColor: '#1E3A5F',
              '&:hover': {
                backgroundColor: '#1E3A5F',
                boxShadow: 'none',
              },
            }}
            variant="contained"
            onClick={handleUpdate}
            loading={loading}
          >
            Save
          </LoadingButton>
        </Card>
      </>
    );
  };
  
  export default UpdatePhoneNumber;
  